import type { JSX } from "react";

import { PRIORITY_BADGE_STYLES } from "../utils/priority";
import type { PriorityLevel } from "../utils/priority";

interface PriorityBadgeProps {
  priority: string;
}

/**
 * The "<level> Priority" pill on a recommendation card.
 *
 * Says "Priority" because that is what the dropdown selecting it is called. The underlying API
 * fields keep their own names — `impact` on an audit suggestion, `severity` on a persona fix — but
 * the reader only ever sees one word for the axis.
 *
 * Shared by the AI Audit and Persona Recommendations tabs. An unrecognised level falls back to the
 * Medium styling rather than rendering unstyled. The colour maps live in `utils/priority.ts` so
 * that a caller wanting only the icon colour does not have to import a component.
 */
const PriorityBadge = ({ priority }: PriorityBadgeProps): JSX.Element => (
  <span
    className={`px-2 py-0.5 text-xs font-semibold rounded-full ${PRIORITY_BADGE_STYLES[priority as PriorityLevel] || PRIORITY_BADGE_STYLES.Medium}`}
  >
    {priority} Priority
  </span>
);

export default PriorityBadge;
